import PortalIdParser from 'PortalIdParser';
import Raven from 'raven-js';
export const serializeError = error => {
  if (error instanceof Error) {
    var _Object$keys;
    const errorAsRecord = error;
    const errorDetails = (_Object$keys = Object.keys(error)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.reduce((acc, key) => {
      acc[key] = errorAsRecord[key];
      return acc;
    }, {});
    return {
      errorMessage: error.message,
      errorName: error.name,
      errorStack: error.stack,
      errorDetails
    };
  }
  if (error && typeof error === 'object') {
    return {
      errorDetails: error
    };
  }
  return {
    errorDetails: String(error)
  };
};
export const reportErrorToLogFetch = ({
  action,
  additionalData,
  error,
  loggingTitle
}) => {
  const portalId = PortalIdParser.get();
  Raven.captureMessage(loggingTitle, {
    extra: Object.assign({
      action
    }, serializeError(error), additionalData),
    tags: Object.assign({}, portalId && {
      hubId: `${portalId}`
    })
  });
};